import React from "react";

interface Props {
  label: string;
  right?: React.ReactNode;
}

export default function SectionHeader({ label, right }: Props) {
  return (
    <div className="flex items-center justify-between mb-3">
      <span className="text-[11px] font-semibold uppercase tracking-widest text-zinc-400">{label}</span>
      {right && <div>{right}</div>}
    </div>
  );
}
